export default {
  default: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/layouts/default.vue")
}